module.exports = __webpack_public_path__ + "img/thumb_06.29be151b.jpg";